import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import PageRichText from "./PageRichText";
import { usePageTextBlock } from "./usePageTextBlock";

interface Props {
  element: DocumentElementType;
}

/**
 * A bulleted-list item. Notion-style: one element per item — the list is just a
 * run of consecutive `page-bullet-list` blocks. Enter continues the list (the
 * type's `next_element` points back at itself); an empty item + Enter exits to
 * text (handled by the editor host).
 */
const PageBulletList: React.FC<Props> = ({ element }) => {
  const { richTextProps } = usePageTextBlock(element);
  return (
    <div className="flex gap-[11px]">
      {/* A CSS dot rather than a "•" glyph: the design's marker is Plus
          Jakarta Sans ink (5.3px round dot, 8.6px advance, centred on the
          27px first line) and the app font draws its bullet glyph smaller —
          a fixed circle reproduces the design in any font. */}
      <span
        aria-hidden
        className="flex h-[27px] w-[9px] flex-none select-none items-center justify-center"
      >
        <span className="h-[5.5px] w-[5.5px] rounded-full bg-[#a5a199]" />
      </span>
      <div className="min-w-0 flex-1">
        <PageRichText {...richTextProps} />
      </div>
    </div>
  );
};

export default PageBulletList;
